import ApiService from "@/core/services/api.service";

// action types
export const API_DEALER_TIREOPTIX_REPORT_ACTION_COUNTRIES_WITH_STATES_LOAD = "action_dealer_tireoptix_report_countries_with_states_load";
export const API_DEALER_TIREOPTIX_REPORT_ACTION_SURVEY_BY_USERS_LOAD = "action_dealer_tireoptix_report_survey_by_users_load";
export const API_DEALER_TIREOPTIX_REPORT_ACTION_LOAD = "action_dealer_tireoptix_report_load";
export const API_DEALER_TIREOPTIX_REPORT_ACTION_DOWNLOAD_PDF = "action_dealer_tireoptix_report_download_pdf";
export const API_DEALER_TIREOPTIX_REPORT_ACTION_DOWNLOAD_EXCEL = "action_dealer_tireoptix_report_download_excel";
export const API_DEALER_TIREOPTIX_DETAILS_GET_ATTACHMENTS = "action_dealer_tireoptix_details_get_attachments";
export const API_DEALER_TIREOPTIX_DETAILS_GET_ATTACHMENT = "action_dealer_tireoptix_details_get_attachment";
export const API_DEALER_TIREOPTIX_DETAILS_GENERATE_ATTACHMENT = "action_dealer_tireoptix_details_generate_attachments";
export const API_DEALER_TIREOPTIX_DETAILS_GET_US_NA_ACCOUNTS_ACTION_LOAD = "action_dealer_tireoptix_details_get_us_na_accounts";

// muts
export const API_DEALER_TIREOPTIX_REPORT_MUTS_SET_COUNTRIES_WITH_STATES = "muts_dealer_tireoptix_report_set_countries_with_states";
export const API_DEALER_TIREOPTIX_REPORT_MUTS_SET_SURVEY_BY_USERS = "muts_dealer_tireoptix_report_set_survey_by_users";
export const API_DEALER_TIREOPTIX_REPORT_MUTS_SET_REPORT_PARAMS = "muts_dealer_tireoptix_report_set_report_params";
export const API_DEALER_TIREOPTIX_DETAILS_MUTS_SET_ATTACHMENTS_PARAMS = "muts_dealer_tireoptix_details_set_attachments_params";
export const API_DEALER_TIREOPTIX_DETAILS_MUTS_SET_US_NA_ACCOUNTS = "muts_dealer_tireoptix_details_set_us_na_accounts";


const state = {
    countries_with_states: [
        {
            country: {
                text: null,
                value: null
            },
            states: [
                {
                    text: null,
                    value: null
                }
            ]
        }
    ],
    survey_by_users: [
        {
            text: null,
            value: null
        }
    ],
    report_params: {
        records_total: null,
        surveys: null,
        tires: null,
        units: null,
        units_with_exceptions: null,
        total_of_trucks_surveyed: null,
        total_of_trailers_surveyed: null,
        exceptions: null,
        data: [
            {
                survey_id: null,
                fleet_location: null,
                survey_date: null,
                survey_by: null,
                fleet_name: null,
                dealer_location: null,
                total_tires: null,
                total_units: null,
                exceptions: null,
                trailer_readiness: null,
            }
        ]
    },
    attachments: [],
    usNa_accounts: [],
}

const getters = {
    getDealerTireOptixReportingCountiesWithStates() {
        return state.countries_with_states;
    },
    getDealerTireOptixReportingReportParams() {
        return state.report_params;
    },
    getDealerTireOptixReportingTableData() {
        return state.report_params.data;
    },
    getDealerTireOptoxReportingTotalRecords() {
        return state.report_params.records_total;
    },
    getDealerTireOptixReportingSurveyByUsers() {
        return state.survey_by_users;
    },
    getDealerTireOptixDetailsGeneratedAttachments() {
        return state.attachments;
    },
    getUsNaAccounts: (state) => {
        return (state.usNa_accounts || []).map((x, i) => ({
            text: x.text,
            value: x.value,
            name: x.name,
            number: x.number
        }));
    }
};

const actions = {
    [API_DEALER_TIREOPTIX_REPORT_ACTION_COUNTRIES_WITH_STATES_LOAD](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.get("survey/get_countries_with_states", context)
                .then(({ data }) => {
                    context.commit(API_DEALER_TIREOPTIX_REPORT_MUTS_SET_COUNTRIES_WITH_STATES, {data});
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [API_DEALER_TIREOPTIX_REPORT_ACTION_SURVEY_BY_USERS_LOAD](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.post("survey/get_survey_by_users", params, context)
                .then(({ data }) => {
                    context.commit(API_DEALER_TIREOPTIX_REPORT_MUTS_SET_SURVEY_BY_USERS, {data});
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [API_DEALER_TIREOPTIX_REPORT_ACTION_LOAD](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.post("survey/report-dealer", params, context)
                .then(({ data }) => {
                    context.commit(API_DEALER_TIREOPTIX_REPORT_MUTS_SET_REPORT_PARAMS, {data});
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [API_DEALER_TIREOPTIX_REPORT_ACTION_DOWNLOAD_PDF](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.postBlob("survey/download_pdf_file_survey_dealer_reports", params, context)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [API_DEALER_TIREOPTIX_REPORT_ACTION_DOWNLOAD_EXCEL](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.postBlob("survey/download_excel_file_survey_dealer_reports", params, context)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [API_DEALER_TIREOPTIX_DETAILS_GET_ATTACHMENTS](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.post("survey/details_get_reports", params, context)
                .then(({ data }) => {
                    context.commit(API_DEALER_TIREOPTIX_DETAILS_MUTS_SET_ATTACHMENTS_PARAMS, {data});
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response || {});
                });
        });
    },
    [API_DEALER_TIREOPTIX_DETAILS_GET_ATTACHMENT](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.postBlob("survey/details_get_report", params, context)
                .then((obj) => {
                    resolve(obj);
                })
                .catch(({ response }) => {
                    reject(response || {});
                });
        });
    },
    [API_DEALER_TIREOPTIX_DETAILS_GENERATE_ATTACHMENT](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.post("survey/details_dealer_generate_reports", params, context)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response || {});
                });
        });
    },
    [API_DEALER_TIREOPTIX_DETAILS_GET_US_NA_ACCOUNTS_ACTION_LOAD](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.get("survey/us_na_accounts", context, { params })
                .then(({ data }) => {
                    const list = Array.isArray(data) ? data : [];
                    context.commit(API_DEALER_TIREOPTIX_DETAILS_MUTS_SET_US_NA_ACCOUNTS, list);
                    resolve(list);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
};

const mutations = {
    [API_DEALER_TIREOPTIX_REPORT_MUTS_SET_COUNTRIES_WITH_STATES](state, {data}) {
        state.countries_with_states = data.countries_with_states;
    },
    [API_DEALER_TIREOPTIX_REPORT_MUTS_SET_SURVEY_BY_USERS](state, {data}) {
        state.survey_by_users = data.survey_by_users;
    },
    [API_DEALER_TIREOPTIX_REPORT_MUTS_SET_REPORT_PARAMS](state, {data}) {
        state.report_params.records_total = data.records_total;
        state.report_params.surveys = data.surveys;
        state.report_params.tires = data.tires;
        state.report_params.units = data.units;
        state.report_params.units_with_exceptions = data.units_with_exceptions;
        state.report_params.total_of_trucks_surveyed = data.total_of_trucks_surveyed;
        state.report_params.total_of_trailers_surveyed = data.total_of_trailers_surveyed;
        state.report_params.exceptions = data.exceptions;
        state.report_params.data = data.data;
    },
    [API_DEALER_TIREOPTIX_DETAILS_MUTS_SET_ATTACHMENTS_PARAMS](state, {data}) {
        state.attachments = (data && data.reports) || [];
    },
	[API_DEALER_TIREOPTIX_DETAILS_MUTS_SET_US_NA_ACCOUNTS](state, data) {
        state.usNa_accounts = data;
    },
	
};

export default {
    state,
    actions,
    mutations,
    getters
};